import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.array.sort";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.search";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import tempTable from "@/components/rw/tempTable/index";
import tempSearch from "@/components/rw/tempSearch/index";
import tempForm from "@/components/rw/tempForm/index";
import tempChart from "@/components/rw/tempChart/index";
import { staCuXiaoList } from '../../../../api/apis';
var MARKET_COL_COUNT = 30;
export default {
  name: 'staCuXiao',
  components: {
    tempTable: tempTable,
    tempSearch: tempSearch,
    tempForm: tempForm,
    tempChart: tempChart
  },
  data: function data() {
    var _this = this; // 构建市场列 tableModel


    var marketColumns = [];

    for (var i = 1; i <= MARKET_COL_COUNT; i++) {
      marketColumns.push({
        "add": 0,
        "detail": 1,
        "excel": 1,
        "groupId": "",
        "label": "市场" + i,
        "rules": [],
        "show": 1,
        "type": "text",
        "width": "120",
        "prop": "market_" + i
      });
    }

    var tableModelArr = [{
      "add": 0,
      "detail": 1,
      "excel": 1,
      "groupId": "",
      "label": "会员编号",
      "rules": [],
      "show": 1,
      "type": "text",
      "width": "150",
      "prop": "number"
    }].concat(marketColumns);
    return {
      activeNames: 'search',
      searchModel_1000: {
        "del": false,
        "id": "id_1000",
        "operateData": [{
          "icon": "el-icon-search",
          "tag": "search",
          "title": "搜索",
          "type": "primary"
        }, {
          "icon": "el-icon-position",
          "tag": "export",
          "title": "导出",
          "type": "primary"
        }],
        "searchData": [{
          "children": [{
            "field": [{
              "desc": "会员编号",
              "key": "number",
              "value": ""
            }],
            "operator": [],
            "placeholder": "请输入会员编号",
            "type": "input-complex"
          }],
          "id": 1,
          "relation": false,
          "relationId": "",
          "remote": false,
          "remoteType": 0,
          "select": 0,
          "title": "会员编号",
          "type": 2,
          "remoteFunc": []
        }],
        "type": "searchTemplate"
      },
      tableModel_1001: {
        "border": true,
        "del": false,
        "headerButton": [],
        "id": "id_1001",
        "isGroup": false,
        "isTree": false,
        "rowButton": [],
        "showPagination": false,
        "showSelection": false,
        "stripe": false,
        "tableAutocompleteProps": {},
        "tableCascaderProps": {},
        "tableFileProps": {},
        "tableModel": tableModelArr,
        "tableName": "t_stacuxiao",
        "tableRadioProps": {},
        "tableSelectProps": {},
        "tableSwitchProps": {},
        "title": "政策促销",
        "type": "tableTemplate"
      },
      remoteFunc: {}
    };
  },
  mounted: function mounted() {
    this.table = this.$refs.ref_1001;
    this.search = this.$refs.ref_1000;
  },
  methods: {
    reqTableData: function reqTableData(params, resolve) {
      var where = {};

      if (this.search) {
        where = this.search.parseWhere();
        params.where = where;
      }

      staCuXiaoList(params).then(function _callee(res) {
        var rows, parsedRows, i, row, detail, parsedRow, j, m;
        return regeneratorRuntime.async(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                rows = (res.data || res.rows || []).slice();
                parsedRows = [];

                for (i in rows) {
                  row = rows[i];
                  detail = row.detail; // detail 可能是 JSON 字符串或数组

                  if (typeof detail === 'string') {
                    try {
                      detail = JSON.parse(detail);
                    } catch (e) {
                      detail = [];
                    }
                  }

                  if (!Array.isArray(detail)) {
                    detail = [];
                  } // 按 total_pv 从大到小排序


                  detail.sort(function (a, b) {
                    return (b.total_pv || 0) - (a.total_pv || 0);
                  });
                  parsedRow = {
                    number: row.number
                  };

                  for (j = 0; j < MARKET_COL_COUNT; j++) {
                    if (j < detail.length) {
                      m = detail[j];
                      parsedRow['market_' + (j + 1)] = m.market + ' (' + (m.total_pv || 0) + ')';
                    } else {
                      parsedRow['market_' + (j + 1)] = '';
                    }
                  }

                  parsedRows.push(parsedRow);
                }

                resolve({
                  total: parsedRows.length,
                  data: parsedRows
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        });
      });
    },
    reqAdd: function reqAdd(isEdit, params, row, resolve) {},
    reqDel: function reqDel(params, resolve) {},
    onClickLink: function onClickLink(prop, row) {},
    onClickRowButton: function onClickRowButton(btnIndex, row) {},
    onClickHeaderButton: function onClickHeaderButton(btnIndex, row) {},
    onSummary: function onSummary(param) {},
    onSwitchChange: function onSwitchChange(val, prop, row) {},
    onClickSearchOperate: function onClickSearchOperate(btnIndex, btnData) {
      if (btnData.tag === this.$tempModel.buttonTag.search) {
        this.table.reloadData();
      } else if (btnData.tag === this.$tempModel.buttonTag.export) {
        this.table.exportExcel();
      }
    },
    onConditionChange: function onConditionChange(tag, index) {
      this.table.reloadData();
    }
  }
};